export const errorConstants = {
  POST_ERROR_REQUEST: "POST_ERROR_REQUEST",
};
